import { jsx as i } from "@emotion/react/jsx-runtime";
import { T as g } from "../TextField/TextField.js";
import x from "@emotion/styled";
import S from "@mui/icons-material/Close";
import { debounce as C } from "@mui/material/utils";
import { useState as l, useEffect as I, useMemo as b } from "react";
const y = x(g)({
  marginBottom: 10,
  input: {
    minWidth: "250px",
    padding: "10px 15px"
  }
});
function v({
  handleChange: e,
  handleClear: n,
  labelText: p,
  debounceTime: r = 1e3,
  variant: c,
  enableClear: o = !1,
  placeholder: m
}) {
  const [t, a] = l(""), [u, d] = l(o);
  I(() => d(o && !!t), [o, t]);
  const h = () => {
    a(""), n && n();
  }, f = b(() => C(e, r), [e, r]);
  return /* @__PURE__ */ i(
    y,
    {
      onChange: (s) => {
        a(s.target.value), f(s);
      },
      label: p,
      variant: c,
      value: t,
      placeholder: m,
      InputProps: {
        endAdornment: u && /* @__PURE__ */ i(
          S,
          {
            sx: { cursor: "pointer", position: "absolute", right: 10 },
            onClick: h,
            "aria-label": "search-clear-button"
          }
        ),
        style: {
          paddingRight: 0
        }
      },
      InputLabelProps: {
        style: { marginTop: "-5px" }
      }
    }
  );
}
export {
  v as S
};
